import React from 'react';
import { FaFilm, FaMapMarkerAlt, FaPhotoVideo, FaUndo } from 'react-icons/fa';

// import required modules

import { abrirDecorador, useDecoradorStatus } from '../../../../../../components/pieces/decorador/decoradorBus';
import { parseLatLngPair } from '../../../../../../utils/latlng';
import { mapaAproximado } from '../../../../../../utils/mapaAproximado';
import styles from './Botoes.module.css';
import Compartilhar from './Compartilhar';

/** Licenças que escondem o botão "Rua" (Street View) quando o imóvel não exibe endereço (cs2165 24/09: só a Rua). */
const CODSITES_SEM_RUA = new Set([2639, 1913, 2165]);
/** Licenças que também escondem o botão "Mapa" nesse caso (o pino entrega a quadra). */
const CODSITES_SEM_MAPA = new Set([1913]);

const Botoes: React.FC<{
    site: any;
    detailsProperties: any;
    setOpenMapa?: any;
    setOpenStreet?: any;
    setOpenOption?: any;
    openOption?: any;
    favorito?: any;
    setFavorito?: any;
}> = ({
    site,
    detailsProperties,
    setOpenMapa,
    setOpenStreet,
    setOpenOption,
    openOption,
    favorito,
    setFavorito: _setFavorito
}) => {
    // useState
    const total_fotos: number =
    detailsProperties?.usa_fotos_empreendimento
    ? (detailsProperties?.empreendimento?.fotos?.length ?? 0) + (detailsProperties?.fotos?.length ?? 0)
    : (detailsProperties?.fotos?.length ?? 0);

    // Chip "✨ Decorar" na fileira da capa — só quando o decorador do tenant está
    // ativo (o host DecorarImovel anuncia via bus). Sem URL: o host usa a 1ª foto.
    // Em V2 o hero "Ver decorado com IA" já ocupa a capa → este chip vira redundante e
    // não é renderizado (só aparece em V1).
    const { ativo: decoradorAtivo, v2: decoradorV2 } = useDecoradorStatus();

    // Só oferece Mapa/Rua quando há coordenada REALMENTE válida. Imóveis do painel novo
    // cuja LatLong ficou "(0, 0)" (ou vazia/malformada) não têm localização plotável —
    // sem isso os botões abriam o mapa na "ilha nula" (0,0), no oceano.
    const temCoordMapa = parseLatLngPair(detailsProperties?.latitude_longitude) != null;

    // Imóvel sem "Exibir endereço no site" (MostrarEnd ≠ 1) entrega a localização por
    // dois caminhos: o Street View mostra a fachada e o pino do Mapa mostra a quadra.
    // Quem pediu para fechar esse vazamento entra nas listas abaixo (allowlist por
    // licença): o cs2639 (16/09) pediu só a Rua; o cs1913 (18/09) pediu Rua e Mapa.
    const semEnderecoNoSite = !detailsProperties?.mostrar_endereco;
    // cs1939 (24/09): Mapa continua, mas aproximado (círculo, sem pino) → a Rua some junto.
    const escondeRua = (semEnderecoNoSite && CODSITES_SEM_RUA.has(Number(site?.id))) || mapaAproximado(site, detailsProperties);
    const escondeMapa = semEnderecoNoSite && CODSITES_SEM_MAPA.has(Number(site?.id));

    return (
        <div className={styles.full}>
            <ul className={styles.baloes}>
                <li key={"fotos"}>
                    <button onClick={() => setOpenOption(1)} className={openOption == 1 ? styles.selecionado : styles.balao}
                        style={site?.cor2 != "#ffffff" && openOption == 1 ? {backgroundColor: site?.cor2} : {}}>
                        <FaPhotoVideo className={styles.icon_balao} />{total_fotos} Fotos
                    </button>
                </li>
                {decoradorAtivo && !decoradorV2 ? (
                    <li key={"decorar"}>
                        <button
                            type="button"
                            className={`${styles.balao} ${styles.balao_decorar}`}
                            title="Decore qualquer foto deste imóvel com IA"
                            aria-label="Decore qualquer foto deste imóvel com IA"
                            onClick={() => abrirDecorador()}
                        >
                            <span className={styles.icon_decorar} aria-hidden="true">✨</span>Decorar
                        </button>
                    </li>
                ) : null}
                {temCoordMapa && site?.mostrar_mapa && !escondeMapa ? <li key={"mapa"}><button className={openOption == 2 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 2 ? {backgroundColor: site?.cor2} : {}} onClick={() => {setOpenOption(0);setOpenMapa(1)}}><FaMapMarkerAlt  className={styles.icon_balao} />Mapa</button></li> : null}
                {temCoordMapa && site?.mostrar_mapa && !escondeRua ? <li key={"mapaStreet"}><button className={openOption == 5 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 2 ? {backgroundColor: site?.cor2} : {}} onClick={() => {setOpenOption(0);setOpenStreet(1)}}><FaMapMarkerAlt  className={styles.icon_balao} />Rua</button></li> : null}
                {detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ? <li key={"video"}><button style={site?.cor2 != "#ffffff" && openOption == 3 ? {backgroundColor: site?.cor2} : {}} onClick={() => setOpenOption(3)} className={openOption == 3 ? styles.selecionado : styles.balao}><FaFilm  className={styles.icon_balao} />Vídeo</button></li> : null}
                {detailsProperties?.tour360 ? <li key={"trou360"}><button className={openOption == 4 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 4 ? {backgroundColor: site?.cor2} : {}} onClick={() => setOpenOption(4)}><FaUndo  className={styles.icon_balao} />Tour 360</button></li> : null}
            </ul>
            {openOption >= 1 && openOption != 2 ? <Compartilhar favorito={favorito} detailsProperties={detailsProperties}></Compartilhar>: null}
        </div>
    );
};

export default Botoes;

export const getServerSideProps = async () => ({ notFound: true });
